import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
//import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons';

import { faTrophy, faAward, faThumbsUp, faPiggyBank, faCalendarCheck, faUtensils, faPlaneDeparture, faTruckFast, faMoneyBill, faLock, faSeedling, faHourglassHalf, faGift, faWineGlass, faLeaf, faEnvelope, faBuilding, faTree } from '@fortawesome/free-solid-svg-icons';

// add the imported icons to the library
library.add(faTrophy, faAward, faThumbsUp, faPiggyBank, faCalendarCheck, faUtensils, faPlaneDeparture, faTruckFast, faMoneyBill, faLock, faSeedling, faHourglassHalf, faGift, faWineGlass, faLeaf, faEnvelope, faBuilding, faTree);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();


// WEBPACK FOOTER //
// ./scripts/fontawesome.js